import React from 'react';
import styled from 'styled-components';
import { CoreMessages } from 'locale';
import { useIntlFormat } from 'utils/intl/useIntlFormat';

interface Props {
  labelId?: CoreMessages;
}

export const SectionLabel: React.FC<React.PropsWithChildren<Props>> = ({ labelId, children }) => {
  const format = useIntlFormat();
  const label = format(labelId ?? 'table.totalCount.loading');

  return <StyledLabel>{labelId ? label : children}</StyledLabel>;
};
const StyledLabel = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  margin-bottom: 2rem;
`;

export default SectionLabel;
